import { FEATURE_LOYALTY_UI_SINGLETON } from 'features/content/hooks/use-feature-loyalty-ui';

import { useFeatureLoyaltyShortCodePaymentSuccessModalQuery } from 'generated/sanity-graphql';

export const useShortCodePaymentSuccessModal = () => {
  const { data, loading } = useFeatureLoyaltyShortCodePaymentSuccessModalQuery({
    variables: { featureLoyaltyUIId: FEATURE_LOYALTY_UI_SINGLETON },
  });

  return { data: data?.LoyaltyUI, loading };
};
